import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ChevronRight, 
  BookOpen, 
  Calendar, 
  Users
} from 'lucide-react';

const BulletinPageHeader = ({ 
  classe, 
  statistiques
}) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      {/* Card principale avec design professionnel */}
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        {/* Header avec bannière bleue */}
        <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center text-white">
              <div className="p-4 bg-white/10 rounded-2xl backdrop-blur-sm mr-4">
                <BookOpen className="h-10 w-10 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold">
                  Bulletins - {classe?.libelle || 'Chargement...'}
                </h1>
                <p className="mt-1 text-blue-100">
                  Gérez et visualisez tous les bulletins de la classe
                </p>
              </div>
            </div>
            
            <div className="mt-4 md:mt-0 flex items-center space-x-3">
              {/* Bouton retour avec flèche à droite */}
              <button
                onClick={() => navigate('/bulletins-notes')}
                className="flex items-center px-6 py-3 bg-white/10 hover:bg-white/20 transition-colors border border-white/20 rounded-xl backdrop-blur-sm text-white font-medium"
              >
                <span className="mr-2">Retour aux Bulletins</span>
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>
          </div>
          
          {/* Informations de la classe */}
          <div className="mt-6 flex items-center space-x-6 text-white/80">
            <div className="flex items-center">
              <Calendar className="h-4 w-4 mr-2" />
              <span>{classe?.niveau?.libelle || 'Niveau'}</span>
            </div>
            <div className="flex items-center">
              <Users className="h-4 w-4 mr-2" />
              <span>{statistiques?.total_bulletins || 0} étudiants</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletinPageHeader;